var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// containers/SortableRow.tsx
import React, { useState, useEffect } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
export function SortableRow(_a) {
    var _b;
    var card = _a.card, virtualStart = _a.virtualStart, totalCount = _a.totalCount, onMoveToPosition = _a.onMoveToPosition;
    var _c = useSortable({ id: card.id }), attributes = _c.attributes, listeners = _c.listeners, setNodeRef = _c.setNodeRef, transform = _c.transform, transition = _c.transition, isDragging = _c.isDragging;
    var _d = useState(String((_b = card.order) !== null && _b !== void 0 ? _b : '')), positionInput = _d[0], setPositionInput = _d[1];
    useEffect(function () {
        var _a;
        setPositionInput(String((_a = card.order) !== null && _a !== void 0 ? _a : ''));
    }, [card.order]);
    var commitPosition = function () {
        var _a;
        var num = parseInt(positionInput, 10);
        if (!Number.isNaN(num) && num >= 1 && num <= totalCount) {
            onMoveToPosition(card.id, num);
        }
        else {
            setPositionInput(String((_a = card.order) !== null && _a !== void 0 ? _a : ''));
        }
    };
    var outerStyle = {
        position: 'absolute', top: 0, left: 0, width: '100%',
        height: 56, transform: "translateY(".concat(virtualStart, "px)"),
    };
    var innerStyle = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.5 : 1,
    };
    return (React.createElement("div", { style: outerStyle },
        React.createElement("div", { ref: setNodeRef, style: innerStyle, className: "card-row" },
            React.createElement("span", __assign({ className: "drag-handle" }, attributes, listeners), "\u283F"),
            card.image && React.createElement("img", { src: card.image, alt: "", className: "card-thumb" }),
            React.createElement("span", { className: "card-title" }, card.title),
            React.createElement("input", { type: "number", min: 1, max: totalCount, className: "card-position-input", value: positionInput, onChange: function (e) { return setPositionInput(e.target.value); }, onBlur: commitPosition, onKeyDown: function (e) {
                    if (e.key === 'Enter')
                        e.currentTarget.blur();
                }, onPointerDown: function (e) { return e.stopPropagation(); } }))));
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/CardExperiences/container/SortableRow.tsx
// module id = 1626
// module chunks = 0